import React from "react";
import { Helmet } from "react-helmet";
import { AnimatePresence } from "framer-motion";
import { GuidedTourProvider, useGuidedTour } from "./GuidedTourContext";
import PresentationCanvas from "./PresentationCanvas";
import TourChrome from "./TourChrome";
import WelcomeScene from "./scenes/WelcomeScene";
import ModelLibraryScene from "./scenes/ModelLibraryScene";
import FillDocumentScene from "./scenes/FillDocumentScene";
import PdfGeneratedScene from "./scenes/PdfGeneratedScene";
import SignScene from "./scenes/SignScene";
import DashboardScene from "./scenes/DashboardScene";
import WriteContractScene from "./scenes/WriteContractScene";
import CreateTemplateScene from "./scenes/CreateTemplateScene";
import MoreFeaturesScene from "./scenes/MoreFeaturesScene";
import CloseScene from "./scenes/CloseScene";

const SCENE_BY_KEY = {
  welcome: WelcomeScene,
  library: ModelLibraryScene,
  fill: FillDocumentScene,
  pdf: PdfGeneratedScene,
  sign: SignScene,
  dashboard: DashboardScene,
  "write-contract": WriteContractScene,
  "create-template": CreateTemplateScene,
  more: MoreFeaturesScene,
  close: CloseScene,
};

const GuidedTourBody = () => {
  const { step } = useGuidedTour();
  const Scene = SCENE_BY_KEY[step.scene] || WelcomeScene;

  return (
    <div className="relative flex h-full min-h-0 flex-1 flex-col overflow-hidden">
      <Helmet>
        <title>Conhecer o sistema — neo-modelos</title>
        <meta
          name="description"
          content="Tour guiado pelos principais fluxos do neo-modelos: modelos, IA, PDF e assinatura."
        />
      </Helmet>
      <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
        <AnimatePresence mode="wait" initial={false}>
          <PresentationCanvas key={step.id}>
            <Scene />
          </PresentationCanvas>
        </AnimatePresence>
        <TourChrome />
      </div>
    </div>
  );
};

const GuidedTour = () => (
  <GuidedTourProvider>
    <GuidedTourBody />
  </GuidedTourProvider>
);

export default GuidedTour;
